import { text, vstack } from '@onbeam/business-styled-system/patterns';
import { FormGroupProps } from './FormGroup.types';
import { cx } from '@onbeam/business-styled-system/css';

export const FormGroup = ({
  label,
  children,
  errorMessage,
  className,
  ...props
}: FormGroupProps) => (
  <div className={cx(vstack({ gap: '2.5' }), className)} {...props}>
    {label && <span>{label}</span>}
    {children}
    {errorMessage && (
      <span
        className={text({
          style: 'small-sm',
          fontWeight: 'bold',
          color: 'red.primary',
        })}
      >
        {errorMessage}
      </span>
    )}
  </div>
);
